import { useEffect, useState } from "react";
import { Alert, Box, FormControlLabel, Stack, Switch } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateCustomersRow } from "../../../../store/actions/dataActions";

const RenderCustomerNotifications = ({
  customerSelectedRow,
  setCustomerSelectedRow,
}) => {
  const dispatch = useDispatch();
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const saved = customerSelectedRow?.notification_settings;

  const [enabled, setEnabled] = useState(!!saved?.enabled);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  useEffect(() => {
    setEnabled(!!saved?.enabled);
    setMsg({ type: "", text: "" });
  }, [customerSelectedRow?.id, saved]);

  const isDirty = enabled !== !!saved?.enabled;

  const handleSave = async () => {
    try {
      setSaving(true);
      setMsg({ type: "", text: "" });

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/admin/update-contractor-notifications`,
        {
          currentSession,
          email: customerSelectedRow?.email,
          enabled,
          emails: [],
          currentPath: window.location.pathname,
        },
        { withCredentials: true },
      );

      if (resp?.data?.success) {
        const notification_settings = {
          enabled,
          emails: [],
        };

        dispatch(
          updateCustomersRow({ ...customerSelectedRow, notification_settings }),
        );
        setCustomerSelectedRow((prev) =>
          prev ? { ...prev, notification_settings } : prev,
        );
        setMsg({ type: "success", text: "Notification settings saved." });
      } else {
        setMsg({
          type: "error",
          text: resp?.data?.message || "Failed to save settings",
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to save settings",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={2}>
        <FormControlLabel
          control={
            <Switch
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
              disabled={saving}
            />
          }
          label="Notify Permit Rockstar team on signature completion and NOC recording"
        />

        {msg.text && (
          <Alert
            severity={msg.type}
            onClose={() => setMsg({ type: "", text: "" })}
          >
            {msg.text}
          </Alert>
        )}

        <LoadingButton
          variant="contained"
          loading={saving}
          disabled={!isDirty}
          onClick={handleSave}
          sx={{ alignSelf: "flex-start" }}
        >
          Save
        </LoadingButton>
      </Stack>
    </Box>
  );
};

export default RenderCustomerNotifications;
